const PrintContainer = (props) => {
  return props.children
}

export default PrintContainer